import { buildModelManager } from "../builder.js";
const DefaultQaMappingMemorySelection = {
  __typename: true,
  id: true,
  approvedById: true,
  canonicalPath: true,
  createdAt: true,
  institution: true,
  nemsisElementId: true,
  notes: true,
  sourceField: true,
  sourceLabel: true,
  updatedAt: true,
  workflowId: true
};
const modelApiIdentifier = "qaMappingMemory";
const pluralModelApiIdentifier = "qaMappingMemories";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaMappingMemorySelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaMappingMemoryGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaMappingMemoryManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaMappingMemorySelection,
  operations
);
export {
  DefaultQaMappingMemorySelection,
  QaMappingMemoryManager
};
//# sourceMappingURL=QaMappingMemory.js.map
